/**
 * Folha de confirmação de saída com trabalho não sincronizado.
 *
 * Três saídas, e a ordem na tela é a ordem da preferência:
 *
 *   1. **Sincronizar agora** — resolve o problema em vez de contorná-lo;
 *   2. **Continuar na conta** — desistir de sair é sempre aceitável;
 *   3. **Descartar e sair** — destrutivo, então vem por último, em coral, e
 *      exige um segundo toque com o número de alterações na frente.
 *
 * Nenhuma delas é automática. O outbox de uma conta nunca sobrevive para a
 * sessão de outra, mas também nunca some sem alguém decidir.
 */
import { useState } from 'react';

import { useSync } from '../sync/useSync';
import { useSyncStore } from '../sync/store';
import { textoDeDescarte } from './logout';
import { useAuthStore } from './store';

export function SairSheet() {
  const pendentes = useAuthStore((s) => s.pendingOnLogout);
  const dispensar = useAuthStore((s) => s.dismissPendingPrompt);
  const signOut = useAuthStore((s) => s.signOut);
  const statusSync = useSyncStore((s) => s.status);
  const { sincronizar } = useSync();

  const [confirmandoDescarte, setConfirmandoDescarte] = useState(false);

  if (pendentes === null) return null;

  async function sincronizarESair() {
    await sincronizar();
    // Se a sincronização resolveu tudo, a saída passa; se sobrou conflito, a
    // folha continua aberta com o novo número.
    await signOut();
  }

  return (
    <div className="sheet" role="dialog" aria-modal="true" aria-labelledby="sair-titulo">
      <div className="sheet__panel">
        <h2 className="sheet__title" id="sair-titulo">
          Você tem alterações não sincronizadas
        </h2>
        <p className="sheet__text">{textoDeDescarte(pendentes)}</p>

        <button
          type="button"
          className="nv-btn nv-btn--primary nv-btn--block"
          onClick={() => void sincronizarESair()}
          disabled={statusSync === 'syncing'}
        >
          {statusSync === 'syncing' ? 'Sincronizando…' : 'Sincronizar agora e sair'}
        </button>

        <button type="button" className="nv-btn nv-btn--secondary nv-btn--block" onClick={dispensar}>
          Continuar na conta
        </button>

        {confirmandoDescarte ? (
          <button
            type="button"
            className="nv-btn nv-btn--danger nv-btn--block"
            onClick={() => void signOut({ discardPending: true })}
          >
            Confirmar: descartar {pendentes} e sair
          </button>
        ) : (
          <button
            type="button"
            className="nv-btn nv-btn--ghost-danger nv-btn--block"
            onClick={() => setConfirmandoDescarte(true)}
          >
            Descartar e sair
          </button>
        )}
      </div>
    </div>
  );
}
